module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "fill-height": ""
    }
  }, [(!_vm.$route.meta.plainLayout) ? _c('app-menu') : _vm._e(), _vm._v(" "), _c('app-content'), _vm._v(" "), (!_vm.$route.meta.plainLayout) ? _c('app-footer') : _vm._e(), _vm._v(" "), _c('app-snackbar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19a49244","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-layouts/app-responsive-layout.vue
// module id = 254
// module chunks = 0